module.exports = __webpack_public_path__ + "static/media/baseline-business.77634cda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/baseline-business.svg
// module id = 53
// module chunks = 0